import { RegionInfo } from '@/models/region';
import { useStore } from 'react-admin';

export const useActiveRegion = (): [RegionInfo | undefined, (region: RegionInfo | undefined) => void] => {
  const [region, setRegion] = useStore<RegionInfo | undefined>('region.active', undefined);
  return [region, setRegion];
}